/// <reference path="../../../typings/browser.d.ts" />
namespace Application.Controllers {
    'use strict';

    import ICloseParameters = ngModal.ICloseParameters;
    import Utils = Common.Utils;

    declare const $: any;

    export interface IJsonModalScope extends ng.IScope {
        formData: any;
        fields: any[];
        json: string
        loadJson: () => void;
        importNodes: () => void;
        parseCsv: (inputTagId: string) => void;
        modalClose: () => void;
        modalSave: () => void;
        getLabel:(id:string,fields:any[])=>string;
    
    }


    export class JsonModalController {
        public static templateURL: string = "decorators/modals/json-modal.html";
        private close: (parameters: ngModal.ICloseParameters) => void;
        public static ID: string = "#id-json-modal";
        public static $name: string = "jsonModalController";
        static $inject = ['$scope', 'jsonService', 'data','close'];
        private $scope: IJsonModalScope;

        constructor($scope: IJsonModalScope, private jsonService: Services.JsonService, private data: any,close: (parameters: ngModal.ICloseParameters) => void) {
            this.$scope = $scope;
            this.close=close
            $scope.formData = data;
            /* $scope.formData = { takerName: 'QWERTY', takerCore: 'C2', protocol: 'RTP', srtServer: 'FR5A2', srtCoreNumber: 'C09', 
                numberOfServices: 3, 
                servicesStartingNumber: 'S341', 
                firstMulticastOfTheRange: '239.20.10.11', firstSrtPortOfTheRange: 48210, 
                srtServerMgtIp: '10.73.89.40', srtServerIntIp: '10.73.89.182', srtServerExtIp: '10.73.89.181'} */
            $scope.fields = [
                { id: 'takerName', label: 'TAKER NAME', model: 'takerName' },
                { id: 'takerCore', label: 'TAKER CORE (C1,C2...)', model: 'takerCore' },
                { id: 'protocol', label: 'PROTOCOL (UDP,RTP)', model: 'protocol' },
                { id: 'srtServer', label: 'SRT SERVER (FR5A1,FR5A2,...)', model: 'srtServer' },
                { id: 'srtCoreNumber', label: 'SRT CORE NUMBER (C06,C07,...)', model: 'srtCoreNumber' },
                { id: 'numberOfServices', label: 'NUMBER OF SERVICES (6,10,...)', model: 'numberOfServices' },
                { id: 'srtProcessRuntime', label: 'SRT PROCESS RUNTIME', model: 'srtProcessRuntime' },
                { id: 'servicesStartingNumber', label: 'SERVICES STARTING NUMBER (S121)', model: 'servicesStartingNumber' },
                { id: 'firstMulticastOfTheRange', label: 'FIRST MULTICAST OF THE RANGE (239.1.1.11)', model: 'firstMulticastOfTheRange' },
                { id: 'firstSrtPortOfTheRange', label: 'FIRST SRT PORT OF THE RANGE', model: 'firstSrtPortOfTheRange' },
                { id: 'srtServerMgtIp', label: 'SRT SERVER MGT IP', model: 'srtServerMgtIp' },
                { id: 'srtServerIntIp', label: 'SRT SERVER INT IP', model: 'srtServerIntIp' },
                { id: 'srtServerExtIp', label: 'SRT SERVER EXT IP', model: 'srtServerExtIp' }
            ];

            
            $scope.loadJson = () => {
                this.jsonService.readJson($scope.json).then((data: any) => {
                    $scope.formData = data;
                }, (error: any) => {
                    console.error('Error:', error);
                });
            };

            $scope.$watch('formData["numberOfServices"]', function(newVal) {
                if (!isImporting) {
                    $scope.formData["srtProcessRuntime"] = newVal;
                }
            });
            
            /**
             * Import SRT EXT fields from a CSV file.
             */
            $scope.importNodes = () => {
                console.log("Entering importNodes");
                const inputTagId = "fileImportSrt";
                let fileinput: HTMLInputElement = <HTMLInputElement>(
                    document.getElementById(inputTagId)
                );
                $("#fileImportSrt").click();
                const handler = function () {
                let f: File = (<HTMLInputElement>fileinput).files[0];

                var nameParts = f.name.split('.');
                var ext = nameParts.length > 1 ? nameParts[nameParts.length - 1].toLowerCase() : '';

                if (ext !== 'csv') {
                    alert("Selected file is not a CSV. Please select a CSV file.");
                    fileinput.value = "";
                    fileinput.removeEventListener("change", handler);
                    return;
                }

                $scope.parseCsv("#" + inputTagId);

                fileinput.value = ""; // reset for same file
                fileinput.removeEventListener("change", handler); // remove listener
            };
            fileinput.addEventListener("change", handler);
            };

            let isImporting = false;

             /**
             * It performs the csv parsing, validates the content and sends data to the backend to save it.
             * @param bundleName
             */
            $scope.parseCsv = (inputTagId: string) => {
                isImporting = true;
                $(inputTagId).parse({
                    config: {
                        delimiter: "auto",
                        skipEmptyLines: true,
                        complete: (result: any) => {
                            console.log("Parsing complete:", result);
                            const arr = result.data;
                            $scope.fields.forEach((field, idx) => {
                                let value = '';
                            if (arr[idx]) {
                                // If the parser split the row into columns (array)
                                if (Array.isArray(arr[idx]) && arr[idx].length > 1) {
                                    value = arr[idx][1] ? arr[idx][1].trim() : '';
                                }
                                // If the parser returned a single string, split manually
                                else if (
                                    typeof arr[idx][0] === 'string' &&
                                    (arr[idx][0].indexOf(';') !== -1 || arr[idx][0].indexOf(',') !== -1)
                                ) {
                                    // Try both delimiters
                                    var parts = arr[idx][0].split(';');
                                    if (parts.length < 2) {
                                        parts = arr[idx][0].split(',');
                                    }
                                    value = parts.length > 1 ? parts[1].trim() : '';
                                }
                            }
                            if (value) {
                                if (
                                    field.model === 'numberOfServices' ||
                                    field.model === 'srtProcessRuntime' ||
                                    field.model === 'firstSrtPortOfTheRange'
                                ) {
                                    $scope.formData[field.model] = parseInt(value, 10);
                                } else {
                                    $scope.formData[field.model] = value;
                                }
                            }
                        });
                        $scope.$apply();
                        isImporting = false;
                    },
                },
            });
        }

            this.$scope.modalSave = (): void => {
                this.jsonService.generateInformation($scope.formData);
                this.close(undefined)

            }; 

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            }
            
            $scope.getLabel= (id: string, fields:any[]): string =>{
                return fields.filter((field)=>field.id===id)[0].label
            }

        }

        
    }

}